import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { MediaRichText } from '@nextiva/rich-text-editor';

import * as DefaultFontSize from '../../../domains/richText/config/DefaultFontSize';

import styles from './HeaderText.scss';

class HeaderText extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    content: PropTypes.object,
    className: PropTypes.string,
  };

  static defaultProps = {
    content: null,
    className: '',
  };

  renderText() {
    const { content, id } = this.props;
    return (
      <MediaRichText
        id={id}
        value={content}
        className={styles.text}
        defaultFontSize={DefaultFontSize.large}
      />
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={cx(styles.container, className)}>{this.renderText()}</div>
    );
  }
}

export default HeaderText;
